module.exports = __webpack_public_path__ + "img/darya.s__600x600.27056a4f.jpg";